export enum MediaInformationModifier {
  MEDIUM = 'medium',
  SMALL = 'small',
  FLOAT_LEFT = 'float-left',
  FLOAT_RIGHT = 'float-right',
  TWO_COLUMNS = 'two-columns',
  TOP_HEADLINE_IMAGE = 'top-headline-image',
  TOP_HEADLINE_IMAGE_SMALL = 'top-headline-image-small',
  PADDING = 'padding',
  POP_UP = 'pop-up',
  SLIDER = 'slider',
  SLIDER_IN_POP_UP = 'slider-in-pop-up',
}
